@use '../../styles/mixins' as *;

.rf-trace-journal-link {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    color: var(--text-link);
    white-space: nowrap;
    text-decoration: underline;
    text-underline-offset: 3px;
    text-decoration-color: transparent;
    transition: text-decoration-color 0.15s;

    svg {
        width: 1em;
        height: 1em;
        flex-shrink: 0;
    }

    &:hover,
    &:focus-visible {
        text-decoration-color: currentcolor;
    }

    &:focus-visible {
        @include focus-outline(2px);
        border-radius: 2px;
    }
}
